module.exports = __webpack_public_path__ + "static/media/fiori3.68bec30d.png";